import { format } from 'date-fns';
import fr from 'date-fns/locale/fr';
import { utcToZonedTime } from 'date-fns-tz';

const setDateLocale = (date, dateFormat) => format(date, dateFormat, { locale: fr });

const formatInTimeZone = (date, timeZone, dateFormat) => format(
  utcToZonedTime(
    new Date(date), timeZone,
  ), dateFormat, { locale: fr },
);

const formattedDate = (dateWithDashes, fmt = 'd MMM yyyy') => setDateLocale(new Date(dateWithDashes), fmt);

const generateYearAgoDate = () => {
  const today = new Date();
  return today.setMonth(today.getMonth() - 12);
};

const generateMonthAgoDate = () => {
  const today = new Date();
  return today.setMonth(today.getMonth() - 1);
};

export const DateTimeService = {
  setDateLocale,
  formatInTimeZone,
  formattedDate,
  generateYearAgoDate,
  generateMonthAgoDate,
};
